import { Controller } from "@hotwired/stimulus";

// The checkout form is `turbo: false` and HTML forms cannot nest, so the cart
// edits on the checkout page are forms of their own. This appends the checkout
// form's fields to each edit's request, so the page the server re-renders keeps
// what the buyer has typed.
//
// It also disables the buy button until that re-render lands. Leaving the
// quantity box by clicking "Finalizar compra" flushes the edit on the same
// gesture, and a placement racing its own edit could price a cart the page
// never showed. A failed request gives the button back.
const SKIPPED = new Set(["authenticity_token", "_method"]);

export default class extends Controller {
	static values = { form: String };

	carry(event) {
		const body = event.detail?.fetchOptions?.body;
		const form = this.form;
		if (!form || typeof body?.append !== "function") return;

		for (const [name, value] of new FormData(form)) {
			if (!SKIPPED.has(name)) body.append(name, value);
		}
		// Added to, never replaced: a second edit finds the buttons already held.
		this.held = [...(this.held ?? []), ...form.querySelectorAll("button[type=submit]:not([disabled])")];
		for (const button of this.held) {
			button.disabled = true;
			button.dataset.held = "true";
		}
	}

	// Also on turbo:before-cache, so Back to this page never restores a held button.
	// shipping-totals then re-derives the button from its own state, since a
	// quote that went stale meanwhile must keep it disabled.
	release() {
		for (const button of this.held ?? []) {
			button.disabled = false;
			delete button.dataset.held;
		}
		this.held = [];
		this.dispatch("released");
	}

	get form() {
		return document.getElementById(this.formValue);
	}
}
